/* eslint-disable */
import * as registry from '../registry.js'
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Planning_Vakanties_Vervallen_DagInputs */

const nl_planning_vakanties_vervallen_dag = /** @type {(inputs: Planning_Vakanties_Vervallen_DagInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("nl", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`Op die dag vervalt 1 gymles uit het rooster.`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`Op die dag vervallen ${i?.count} gymlessen uit het rooster.`);
	return /** @type {LocalizedString} */ ("planning.vakanties.vervallen_dag");
};

/**

* @param {Planning_Vakanties_Vervallen_DagInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const planning_vakanties_vervallen_dag = /** @type {((inputs: Planning_Vakanties_Vervallen_DagInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planning_Vakanties_Vervallen_DagInputs, { locale?: "nl" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_planning_vakanties_vervallen_dag(inputs)
});
export { planning_vakanties_vervallen_dag as "planning.vakanties.vervallen_dag" }